import { PublicKey } from '@solana/web3.js';
import type { Hex } from 'viem';

/** Everything chain-specific the client needs, sourced from build-time env. */
export const config = {
  solana: {
    rpcUrl: import.meta.env.VITE_SOLANA_RPC_URL ?? 'https://api.devnet.solana.com',
    programId: new PublicKey(
      import.meta.env.VITE_SOLANA_ESCROW_PROGRAM_ID ??
        '62HtHo8YrnV7VaGsTwqfkAy66mPB5N2XGRoGKo3YHwhB',
    ),
    usdcMint: new PublicKey(
      import.meta.env.VITE_SOLANA_USDC_MINT ?? '4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU',
    ),
  },
  ethereum: {
    rpcUrl: import.meta.env.VITE_ETHEREUM_RPC_URL ?? 'https://eth.llamarpc.com',
    escrowAddress: (import.meta.env.VITE_ETHEREUM_ESCROW_ADDRESS ??
      '0x0000000000000000000000000000000000000000') as Hex,
    usdcAddress: (import.meta.env.VITE_ETHEREUM_USDC_ADDRESS ??
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48') as Hex,
  },
} as const;
